import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#0A0A0A] bg-[#FFE8A8] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img
            src="/divergent-cinema-logo.png"
            alt="Divergent Cinema Film Festival logo"
            className="h-24 w-auto object-contain mb-4"
            data-testid="footer-logo"
          />
          <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#1A5DFF] mb-3">Divergent Cinema CIC</div>
          <h3 className="font-heading text-2xl text-[#0A0A0A] leading-tight mb-4">
            A non-profit festival platforming neurodivergent filmmakers — autistic, ADHD, dyslexic, Tourette&apos;s, and beyond.
          </h3>
          <Link
            to="/membership"
            data-testid="footer-membership-link"
            className="inline-flex items-center bg-[#FF2E63] text-[#FFF8E7] hover:bg-[#E0204F] rounded-none px-6 py-3 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FF2E63]"
          >
            Become a member →
          </Link>
        </div>

        <div className="md:col-span-3">
          <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#1A5DFF] mb-3">Explore</div>
          <ul className="space-y-2 text-[#0A0A0A]">
            <li><Link to="/" data-testid="footer-link-home" className="hover:text-[#FF2E63]">Home</Link></li>
            <li><Link to="/films" data-testid="footer-link-films" className="hover:text-[#FF2E63]">Films</Link></li>
            <li><Link to="/films/submit" data-testid="footer-link-films-submit" className="hover:text-[#FF2E63]">Submit a film</Link></li>
            <li><Link to="/productions" data-testid="footer-link-productions" className="hover:text-[#FF2E63]">Productions</Link></li>
            <li><Link to="/festival" data-testid="footer-link-festival" className="hover:text-[#FF2E63]">Festivals & Events</Link></li>
            <li><Link to="/network" data-testid="footer-link-network" className="hover:text-[#FF2E63]">Network</Link></li>
            <li><Link to="/network/join" data-testid="footer-link-network-join" className="hover:text-[#FF2E63]">Join the network</Link></li>
            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-[#FF2E63]">About</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-[#FF2E63]">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#1A5DFF] mb-3">Contact</div>
          <p className="text-[#2C2C2C] leading-relaxed">
            Get in touch about submissions, partnerships, or accessibility on set.
          </p>
          <a
            href="mailto:create@divergentcinema.co.uk"
            data-testid="footer-email"
            className="mt-2 inline-block text-[#0A0A0A] underline underline-offset-4 hover:text-[#FF2E63]"
          >
            create@divergentcinema.co.uk
          </a>
        </div>
      </div>
      <div className="border-t border-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-[#2C2C2C]">
          <div>© {new Date().getFullYear()} Divergent Cinema CIC. A Community Interest Company.</div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-[#FF2E63]">Privacy</Link>
            <Link to="/cookies" data-testid="footer-link-cookies" className="hover:text-[#FF2E63]">Cookies</Link>
            <span className="text-[#2C2C2C]">Built with accessibility in mind. WCAG 2.2 AA targeted.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

